module.exports = __webpack_public_path__ + "img/zh_CN-top-bg.cf34a62e.png";